module.exports = __webpack_public_path__ + "static/location-info1-e70a4b4e272a80f45697a360acf7083d.jpg";